import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {NPC} from '../state/NPC.js';
import {KillQuest} from '../state/quests/KillQuest.js';
import {Reward} from '../state/Reward.js';
import {QuestDescription} from './quest-description.js';

export class NpcComponent extends Component {
    static TypeName = 'npc-component';

    @property.string('Joe')
    npcName = 'Joe';

    private _data!: NPC;
    private _questIndicator?: Object3D;

    start() {
        this._data = new NPC(this.npcName);

        const questDescription = this.object.getComponent(QuestDescription)!;

        const quest = new KillQuest(
            questDescription.questID,
            questDescription.questDescription,
            questDescription.questCount,
            questDescription.questEnemy,
            new Reward(questDescription.questReward),
            questDescription.questLevel
        );

        this._data.quests.push(quest);

        this._questIndicator = this.object.findByNameDirect('QuestIndicator')[0];
        if (this._questIndicator) {
            const text = this._questIndicator.getComponent('text')!;
            quest.onCompleted.add(() => {
                text.active = true;
                text.text = '!';
            });

            quest.onRewarded.add(() => {
                text.active = false;
            });

            quest.onAssigned.add(() => {
                text.active = false;
            });
        }
    }

    getData() {
        return this._data;
    }
}
